import { render, staticRenderFns } from "./BaseConfirmDialogContainer.vue?vue&type=template&id=cb9e3fe8&scoped=true&"
import script from "./BaseConfirmDialogContainer.vue?vue&type=script&lang=js&"
export * from "./BaseConfirmDialogContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9e3fe8",
  null
  
)

export default component.exports